import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import {
  getBuildings,
  getUnits,
  getUnitsExcludingBuildingFilter,
  setFilters,
  setPage
} from '../../../actions/viewerActions'
import { classes, UseMinimapStyle } from './style'
import { useTheme } from '@mui/styles'

const getTemplate = (theme, building, unitsExcludingBuilding) => {
  const unitsByBuilding = unitsExcludingBuilding.reduce((unitsResult, currentUnit) => {
    if (currentUnit.buildingID === building.id) {
      unitsResult.push(currentUnit)
    }
    return unitsResult
  }, [])

  return `
        <div>
            <img 
            src="${building.thumbnail}"
            alt="UnitPreview" 
            style="
                width: 150px;
                height: 100px;
                object-fit: cover;
                border-radius: 5px 5px 0 0;
            ">
            <hr style="margin-top:-6px;margin-bottom: 10px;border: 0;border-top: 3px solid ${theme.palette?.primary.main}">
            <p style="margin:0; text-align: center; padding-left: 10px; font-family:'Lato',sans-serif; color:darkred; font-size: 0.875rem">
              <strong>${building.address}</strong>
            </p>
            <p style="margin:0; text-align: left; padding-left: 10px; font-family:'Lato',sans-serif; color: gray; font-weight: 400; font-size: 0.75rem">
                <span>Available Units:</span> 
                <strong style="text-transform: capitalize">${unitsByBuilding.length}</strong>
                <br>
                <span>Amenities:</span> 
                <strong style="text-transform: capitalize">${building.amenities}</strong>
                <br>
                <span>State:</span> 
                <strong style="text-transform: capitalize">${building.state}</strong>
            </p>
        </div>
        `
}

export default function UseMiniMap () {
  const dispatch = useDispatch()
  const buildingsStore = useSelector(state => state.viewer.buildings)
  const unitsExcludingBuilding = useSelector(state => state.viewer.unitsExcludingBuilding)
  const filters = useSelector(state => state.viewer.filters)
  const colorMode = useSelector(state => state.viewer.colorMode)
  const theme = useTheme()

  const [buildingsByUnits, setBuildingsByUnits] = useState([])

  const onClickPoint = (building) => {
    const filtered = { ...filters }
    filtered.building = building.id
    dispatch(setPage(1))
    dispatch(setFilters(filtered)).then(() => {
      dispatch(getUnits(filtered))
    })
  }

  const getBuildingProperties = building => {
    return {
      id: building.id,
      type: 'Feature',
      properties: {
        description: getTemplate(theme, building, unitsExcludingBuilding),
        ...building
      },
      geometry: {
        type: 'Point',
        coordinates: building.center
      }
    }
  }

  const generateCanvas = () => {
    if (!isEmpty(buildingsByUnits)) {
      const buildings = cloneDeep(buildingsByUnits)
      const features = []

      buildings.forEach(building => {
        if (building && building.center) {
          const feature = getBuildingProperties(building)
          features.push(feature)
        }
      })
      const center = (buildings.length && buildings[0]?.center) || [-73.96368733310645, 40.77900196036666]

      const MiniMap = window.miniMap
      window.useMiniMap = new MiniMap('yyg32322', center, features, onClickPoint, colorMode)
      const miniMap = window.useMiniMap
      miniMap.render('myMiniMap')
    }
  }

  const setBuildings = () => {
    setBuildingsByUnits([])
    unitsExcludingBuilding.forEach(unit => {
      if (!buildingsByUnits.includes(unit.buildingID)) {
        setBuildingsByUnits((old) => {
          const building = buildingsStore.find(_building => _building.id === unit.buildingID)
          return [...old, building]
        })
      }
    })
  }

  useEffect(() => {
    dispatch(getBuildings())
  }, [])

  useEffect(() => {
    generateCanvas()
  }, [JSON.stringify(buildingsByUnits), colorMode])

  useEffect(() => {
    dispatch(getUnitsExcludingBuildingFilter(filters))
  }, [filters, buildingsStore])

  useEffect(() => {
    setBuildings()
  }, [unitsExcludingBuilding])

  return (
        <UseMinimapStyle className={classes.root}>
            <div id="myMiniMap"/>
        </UseMinimapStyle>
  )
}
